var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        _vm.layout,
        { tag: "component" },
        [
          _c(
            "template",
            { slot: "toolbar-title" },
            [
              _c(
                "v-toolbar-title",
                {
                  staticClass: "pl-3 pr-2",
                  staticStyle: { cursor: "pointer" },
                  attrs: { color: "accent", "data-cy": "toolbar-title" },
                },
                [_vm._v("Cyber Switch")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("notifications", {
        attrs: {
          group: "notifications-bottom-right",
          position: "bottom right",
          classes: "custom-notification",
        },
      }),
      _vm.loading
        ? _c(
            "BlockUI",
            { attrs: { id: "ui-loader-1234" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }